
import React, { useState } from "react";

const AddDayPopup = ({ onClose, onAddDay }) => {
  const [selectedDate, setSelectedDate] = useState("");
  const [dayType, setDayType] = useState("Travel Day");

  
  


  const handleAddDay = () => {
    if (!dayType) {
      alert("Please select a day type.");
      return;
    }

    // Include the date only if it's provided
    onAddDay({ ...(selectedDate && { date: selectedDate }), type: dayType });
    onClose();
  };
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div className="bg-white rounded-lg p-6 shadow-lg w-96">
      <div className="flex justify-between items-center mb-4">
      <h2 className="text-xl font-bold">Add a Day </h2>
        <button onClick={onClose} className="text-gray-600 hover:text-black ">
            ✖
          </button>
       
        </div>
        <label className="block mb-2 font-medium">
  Select Date:
  <input
    type="date"
    value={selectedDate}
    onChange={(e) => setSelectedDate(e.target.value)}
    className="w-full border border-gray-300 rounded-md px-3 py-2 mt-1"
    min={new Date().toISOString().split("T")[0]} // Set minimum date to today
  />
</label>

        <div className="flex flex-wrap mt-4">
          {["Arrival Day", "Departure Day", "Travel Day", "Rest Day"].map(
            (type) => (
              <button
                key={type}
                className={`px-4 py-2 m-1 rounded ${
                  dayType === type
                    ? "bg-blue-500 text-white"
                    : "bg-gray-100 text-gray-800"
                }`}
                onClick={() => setDayType(type)}
              >
                {type}
              </button>
            )
          )}
        </div>
        <div className="mt-6 flex justify-end space-x-3">
        
          <button
            onClick={handleAddDay}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Add Day
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddDayPopup;